import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_14: FaireProductEntity = {
  token: "driftless-studios-14",
  type: "product",
  name: "I Have Found The One Whom My Soul Loves Wood Wall Art - 24x6",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/a62ce01131ed369a125c9cc4e1b7760a74f23ba4653fba248cad2ffb32348980.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
